export const LogoMark = ({ size = 40 }) => (
  <img
    src="/logo.webp"
    width={size}
    height={size}
    alt="Logo de l'auto-école Bestconduite78 à Chatou"
    className="rounded-[26%] shadow-sm"
  />
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="site-logo">
    <LogoMark size={compact ? 34 : 40} />
    <div className="leading-none">
      <span className="font-heading font-800 text-slate-900 text-lg sm:text-xl font-extrabold tracking-tight">
        Best<span className="text-violet-700">conduite</span>
        <span className="text-violet-500">78</span>
      </span>
      <span className="hidden sm:block text-[10px] uppercase tracking-[0.28em] text-slate-400 mt-1 font-semibold">
        Auto-école · Chatou
      </span>
    </div>
  </div>
);
